import { UpdateDiscountCode, UpdateDiscountCodeVariables } from '@/gql/graphql'
import { MutationFunctionOptions, useMutation } from '@apollo/client'

import { TopNavBannerDiscountCodeId } from '@/components/elements/molecules/TopNavBanner/TopNavBanner'

import { REDEEM_DISCOUNT_CODE } from './mutations/RedeemDiscountCode'

type UseUpdateDiscountCode = {
  redeemDiscountLoading: boolean
  redeemDiscount: (
    options?: MutationFunctionOptions<
      UpdateDiscountCode,
      UpdateDiscountCodeVariables
    >
  ) => void
  updateSessionDiscountCode: (discountCode?: string) => void
}

const useUpdateDiscountCode = (
  onError?: (error: Error) => void,
  onSuccess?: (
    discountCodeId: string | undefined,
    discountCodeCode: string | undefined
  ) => void
): UseUpdateDiscountCode => {
  // NOTE: Sets the discount code in session storage, to be sent and updated on the BE,
  // and ensure we charge the user what they're seeing on the Checkout page
  const updateSessionDiscountCode = (discountCode?: string) => {
    if (discountCode) {
      window.sessionStorage.setItem('discount_code', discountCode)
    } else {
      window.sessionStorage.removeItem('discount_code')
    }
  }

  // Redeem a Discount
  const [redeemDiscount, { loading: redeemDiscountLoading }] = useMutation<
    UpdateDiscountCode,
    UpdateDiscountCodeVariables
  >(REDEEM_DISCOUNT_CODE, {
    onError: (error) => {
      if (onError) onError(error)
      updateSessionDiscountCode() // Clears whatever value is on session
    },
    onCompleted: (data) => {
      if (onSuccess)
        onSuccess(
          data.addDiscountToGuest?.guest.discountCode?.id,
          data.addDiscountToGuest?.guest.discountCode?.code
        )

      // Set the discount code id value for the
      // Top Nav Banner so it can re-query for the new
      // discount information
      TopNavBannerDiscountCodeId(
        data.addDiscountToGuest?.guest.discountCode?.id
      )

      updateSessionDiscountCode(
        data.addDiscountToGuest?.guest.discountCode?.code
      )
    }
  })

  return {
    redeemDiscountLoading,
    redeemDiscount,
    updateSessionDiscountCode
  }
}

export default useUpdateDiscountCode
